export default __webpack_public_path__ + "static/media/colgante-cruz.a88accbe.png";